export default "__VITE_ASSET__DckdNW51__"